import {
  AUTH_USER,
  UNAUTH_USER,
  OPEN_SIGN_POPUP,
  CLOSE_SIGN_POPUP,
  GUEST_USER,
  UPDATE_USER_DETAILS,
  UPDATE_MEAL_PLAN,
  REMOVE_USER,
  UPDATE_GUEST_USER,
  REMOVE_GUEST_USEER,
  AUTH_GUEST,
} from '../constants/actionTypes';
import { get } from 'lodash';

const INITIAL_STATE = {
  error: '',
  authenticated: false,
  content: '',
  name: 'Guest',
  showSigninPopUp: false,
  guest: false,
  loginUserDetails: false,
  tokenId: '',
  jwt: '',
  signInCaller: false,
};

export default function(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case AUTH_GUEST:
      return {
        ...state,
        guestToken: action.guestToken, // guestToken to hit new backend
        tokenId: action.tokenId, // tokenId have to be removed after all PHP queries are removed
        jwt: action.jwt,// jwt have to be removed after all PHP queries are removed
        restaurantLocation: action.restaurantLocation,
      };
    case AUTH_USER:
      return {
        ...state,
        error: '',
        message: '',
        authenticated: true,
        name: action.name,
        loginUserDetails: action.userData,
        tokenId: action.tokenId,
        jwt: action.jwt,
        showSigninPopUp: false,
        customerToken: action.customerToken, // Token for Customer on new backend
      };
    case REMOVE_USER:
      return {
        ...state,
        authenticated: false,
        loginUserDetails: '',
      };
    case UNAUTH_USER:
      localStorage.removeItem('auth');
      return {
        ...state,
        authenticated: false,
        error: action.payload,
        tokenId: action.tokenId,
        jwt: action.jwt,
      };
    case OPEN_SIGN_POPUP:
      return {
        ...state,
        showSigninPopUp: true,
        signInCaller: action.signInCaller,
      };
    case CLOSE_SIGN_POPUP:
      return { ...state, showSigninPopUp: false };
    case GUEST_USER:
      return { ...state, guest: true };
    case UPDATE_USER_DETAILS:
      return { ...state, loginUserDetails: action.data };
    case UPDATE_GUEST_USER:
      var guestUserDetails = {};
      if (state.loginUserDetails.guestUser)
        guestUserDetails = state.loginUserDetails.guestUser;
      return {
        ...state,
        loginUserDetails: {
          ...state.loginUserDetails,
          guestUser: Object.assign(guestUserDetails, payload),
        },
      };
    case REMOVE_GUEST_USEER:
      return {
        ...state,
        loginUserDetails: '',
      };
    case UPDATE_MEAL_PLAN:
      return {
        ...state,
        loginUserDetails: {
          ...state.loginUserDetails,
          mealplan: {
            ...state.loginUserDetails.mealplan,
            ...payload,
          },
        },
      };
    default:
      return state;
  }
}

export const getUserId = state => get(state, 'auth.loginUserDetails.id', 0);
export const getUserDetails = state => state.auth.loginUserDetails;
export const getTokenId = state => state.auth.tokenId;
export const getJWT = state => state.auth.jwt;

export const getGuestToken = state => state.auth.customerToken;
export const getCustomerToken = state => state.auth.customerToken;



// WEBPACK FOOTER //
// ./src/redux/reducers/authenticationReducers.js